import { Text } from '@bigcommerce/big-design';
import { CAFlagIcon, USFlagIcon } from '@bigcommerce/big-design-icons/flags';

export function AddressText({ address }) {
	const {
		first_name,
		last_name,
		company,
		street_1,
		street_2,
		city,
		state,
		zip,
		country,
	} = address;
	const hasStreet2 =
		typeof street_2 === 'string' &&
		street_2.trim() !== '' &&
		street_2 !== 'undefined' &&
		street_2 !== 'null';

	return (
		<>
			<dd>
				<Text>
					{first_name} {last_name}
					<br />
					{company ? (
						<>
							{company}
							<br />
						</>
					) : (
						''
					)}
					{street_1}
					<br />
					{hasStreet2 ? (
						<>
							{street_2}
							<br />
						</>
					) : (
						''
					)}
					{city}, {state} {zip}
				</Text>
			</dd>

			<dt>
				<div className="icon-image">
					{country === 'United States' ? (
						<USFlagIcon />
					) : (
						<CAFlagIcon />
					)}
				</div>
			</dt>
			<dd>
				<Text>{country}</Text>
			</dd>
		</>
	);
}
